import { ExchangeColor } from '@api/returns/types'
import axios from 'axios'

const productByIdQuery = `query ProductByIdQuery($id: Long!) {
  productById(id: $id) {
    handle
  }
}`

export const getProductById = async (
  variables: Record<string, string | number>
) => {
  const { data } = await axios({
    method: 'post',
    url: `https://${process.env.CONTENT_API_DOMAIN}/graphql`,
    headers: {
      Accept: 'application/json',
      'x-api-key': process.env.CONTENT_API_API_KEY!
    },
    data: {
      query: productByIdQuery,
      variables
    }
  })

  return data.data
}

const productColorQuery = `
query ProductColours($productType: String!) {
  productsByType(product_type: $productType) {
    product_types {
      product_type
      items {
        title
        product_id
        pdpPrice
        compare_at_price
        image {
          src
        }
        sku_16
        color {
          primary
          secondary
          image
        }
      }
    }
  }
}
`

export type ProductColorsByType = {
  product_types: Array<{
    product_type: string
    items: ExchangeColor[]
  }>
}

export const getProductColors = async (
  variables: Record<string, string | number>
): Promise<{ productsByType: ProductColorsByType }> => {
  const { data } = await axios({
    method: 'post',
    url: `https://${process.env.CONTENT_API_DOMAIN}/graphql`,
    headers: {
      Accept: 'application/json',
      'x-api-key': process.env.CONTENT_API_API_KEY!
    },
    data: {
      query: productColorQuery,
      variables
    }
  })

  return data.data
}
